var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0667 2.46796C11.3333 1.66796 10.5 2.56796 10.5 4.73462V7.13462C10.5 9.16796 11.3333 10.0013 13 10.0013H15.7667C17.9333 10.0013 18.8333 9.16796 18.0333 6.43462C17.85 5.81796 17.55 5.22629 17.1667 4.69296",
    stroke: "#669F2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26669 12.0271C1.59169 7.82708 4.37502 4.12708 8.21669 3.34375",
    stroke: "#669F2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1668 12.25C16.3918 16.1083 12.6918 18.9083 8.4835 18.225C6.62516 17.9333 4.97516 16.925 3.8335 15.5083",
    stroke: "#669F2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.cec577584f83fa143df3bc4d0e378e3e.svg";
export { ForwardRef as ReactComponent };